import axiosInstance from '../utils/axiosInstance';
import { BASE_URL } from '../constants';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';



const getApi = (endPoint) => ({
    get: async () => {
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'get',
            withCredentials: true,
        };

        try {
            return await axiosInstance(options);
        } catch (error) {
            throw error;
        }
    },
    post: async (data) => {
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'post',
            data,
            withCredentials: true,
        };

        try {
            return await axiosInstance(options);
        } catch (error) {
            throw error;
        }
    },
    patch: async (data) => {
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'patch',
            data,
            withCredentials: true,
            headers: {
                'Content-Type': FormData ? 'multipart/form-data' : 'application/json'
            }
        };

        try {
            return await axiosInstance(options);
        } catch (error) {
            throw error;
        }
    },
    put: async (data) => {
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'put',
            data,
            withCredentials: true,
        };

        try {
            return await axiosInstance(options);
        } catch (error) {
            throw error;
        }
    },
    delete: async (data) => {
        const options = {
            url: `${BASE_URL}${endPoint}`,
            method: 'delete',
            data,
            withCredentials: true,
        };

        try {
            return await axiosInstance(options);
        } catch (error) {
            throw error;
        }
    },
});

export default function sliceCreator(sliceName, endPoint, method) {
    const action = createAsyncThunk(
        (`${sliceName}/${method}`).toUpperCase(),
        async (data, { rejectWithValue }) => {
            try {
                const response = await getApi(data?.endPoint || endPoint)[method](data);
                return response.data;
            } catch (err) {
                if(err.status === 403 && err.response.data?.message === 'Client subscription is not active') {
                    //i want modify local storage here to updated subscription status
                    localStorage.setItem('userDetails', JSON.stringify({
                        ...JSON.parse(localStorage.getItem('userDetails')),
                        Client: {
                            ...JSON.parse(localStorage.getItem('userDetails')).Client,
                            subscription_status: 'expired'
                        }
                    }));
                }
                return rejectWithValue(err.response.data);
            }
        }
    );

    const clearData = `${(method).toUpperCase()}/clear`;

    const slice = createSlice({
        name: (sliceName).toUpperCase(),
        initialState: {
            loading: false,
            successData: null,
            error: false,
            errorInfo: null,
        },
        reducers: {
            [clearData]: (state) => {
                state.loading = false;
                state.successData = null;
                state.error = false;
                state.errorInfo = null;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(action.pending, (state) => {
                    state.loading = true;
                    state.error = false;
                    state.errorInfo = null;
                })
                .addCase(action.fulfilled, (state, action) => {
                    state.loading = false;
                    state.successData = action.payload;
                })
                .addCase(action.rejected, (state, action) => {
                    state.loading = false;
                    state.error = true;
                    state.errorInfo = action.payload;
                });
        },
    });

    return {
        asyncAction: action,
        reducer: slice.reducer,
        clearData: slice.actions[clearData] 
    };
}